import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { DeleteSubscriberModel } from 'src/app/admin-panel/models/members/delete-subscriber.model';
import { AppUserService } from 'src/app/admin-panel/services/members/app-user.service';

@Component({
  selector: 'app-archive-app-user',
  templateUrl: './archive-app-user.component.html',
  styleUrls: ['./archive-app-user.component.scss']
})
export class ArchiveAppUserComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public spinner: boolean = false;
  public deleteSubscriberModel : DeleteSubscriberModel = new DeleteSubscriberModel()
  public active:boolean=false;
  //#endregion
  //#region Constructor
  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    public appUserService: AppUserService
  ) { 
    if (this.config.data != undefined && this.config.data.id) {     
      this.deleteSubscriberModel.subscriberId = this.config.data.id;
      this.active = this.config.data.active
    }
  }

  ngOnInit(): void {
  }
  //#endregion
  //#region Public Methods
  suspendsubcriber() {
    this.spinner = true
    this.appUserService.suspendsubscriber(this.deleteSubscriberModel)
    .pipe(takeUntil(this.unsubscribe))
    .subscribe({
      next: (response) => {  
        this.spinner = false      
        this.ref.close(true)
      },
      error: errorResponse => {
        this.spinner = false 
      }
    });
  }
  unsuspendsubcriber(){
    this.spinner = true
    this.appUserService.unsuspendsubscriber(this.deleteSubscriberModel)
    .pipe(takeUntil(this.unsubscribe))
    .subscribe({
      next: (response) => {  
        this.spinner = false      
        this.ref.close(true)
      },
      error: errorResponse => {
        this.spinner = false 
      }
    });
  }
  cancel() {
    this.ref.close(false)
  }
  //#endregion
}
